<template>
	<div>
		<div>
			<Input
				v-model="account"
				pre_icon="icon-yonghuming"
				:placeholder="$t('user.components.verifycode.phone')"
			/>
		</div>
		<div>
			<input hidden />
			<VerifyInput
				ref="verifyInput"
				pre_icon="icon-ziyuan"
				v-model="code"
				:placeholder="$t('user.components.verifycode.vericode')"
				@sendCode="sendCode"
			/>
		</div>
		<div>
			<button class="btn btn-blue" @click="toLogin">{{$t('user.components.verifycode.login')}}</button>
		</div>
	</div>
</template>
<script>
import { mapActions } from "vuex";
import { is_Phone } from "@/utils/vaildate";
import { VerifyInput, Input } from "@/components";
export default {
	components: {
		VerifyInput,
		Input,
	},
	data() {
		return {
			account: "",
			code: "",
		};
	},
	methods: {
		...mapActions("user", ["login", "sendSmsCode", "walletLogin"]),
		async sendCode() {
			if (!is_Phone(this.account)) {
				this.$tooltip.warning(this.$t('user.components.verifycode.tip-phone'));
				return;
			}
			try {
        this.$refs.verifyInput.loading = true;
				await this.sendSmsCode({account:this.account});
        this.$refs.verifyInput.countDown();
         this.$refs.verifyInput.loading = false;
				this.$tooltip.success(this.$t('user.components.verifycode.sendsuccess'));
			} catch (e) {
        this.$refs.verifyInput.loading = false;
				this.$tooltip.error(e);
			}
		},
		vaild() {
			if (!this.account) {
				this.$tooltip.warning(this.$t('user.components.verifycode.phone'));
				return false;
			}
			if (!is_Phone(this.account)) {
				this.$tooltip.warning(this.$t('user.components.verifycode.tip-phone'));
				return false;
			}
			if (!this.code) {
				this.$tooltip.warning(this.$t('user.components.verifycode.tip-code'));
				return false;
			}
			return true;
		},
		async toLogin() {
			if (this.vaild()) {
				try {
					await this.login({
						params: {
							account: this.account,
							password: this.code,
						},
						eventName: "loginByPhoneCode",
					});
					await this.walletLogin();
					this.$tooltip.success(this.$t('user.components.verifycode.logsuccess'));
					this.$router.push({ name: "home" });
				} catch (e) {
					this.$tooltip.error(e);
				}
			}
		},
	},
};
</script>